/** Zero-padded ordinal for the design's numbered cells: 0 → "01". */
export const padNumber = (index: number) => String(index + 1).padStart(2, '0')
